import { render, staticRenderFns } from "./carriers.vue?vue&type=template&id=4cf87d8f&"
import script from "./carriers.vue?vue&type=script&lang=js&"
export * from "./carriers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports